import {createContext} from "react";

export const DrawerContext = createContext<{
    variant: IDrawerVariant;
    systemTheme: IDrawerTheme;
}>({variant: "right", systemTheme: "light"});

export type IDrawerVariant = "left" | "right";
export type IDrawerTheme = "dark" | "light";

export const DrawerContextProvider = DrawerContext.Provider;
import {createContext} from "react";

export const DrawerContext = createContext<{
    variant: IDrawerVariant;
    systemTheme: IDrawerTheme;
}>({variant: "right", systemTheme: "light"});

export type IDrawerVariant = "left" | "right";
export type IDrawerTheme = "dark" | "light";

export const DrawerContextProvider = DrawerContext.Provider;
